import React from "react";
import { Paper, Stack } from "@mui/material";
import styled from "styled-components";
import ShowWithSkeleton from "../utils/show-with-skeleton";
import WorkBubbleChart from "./bubble-chart";
import useWindowSize from "./use-window-resize";

const StyledBubbleChartCard = styled(Paper)`
    height: 120px;
    border-radius: 0;
`;

const CardTitle = styled.h3`
    font-size: 14px;
    font-weight: 400;
`;

const BubbleChartCard = ({ fetchAction, parameters }) => {
    const size = useWindowSize();
    const [width, setWidth] = React.useState(null);
    const div = React.useCallback(
        (node) => {
            if (node !== null) {
                setWidth(node.getBoundingClientRect().width);
            }
        },
        [size]
    );

    return (
        <StyledBubbleChartCard ref={div}>
            <Stack direction="column" ml={3} pt={0.5} style={{ height: "100%" }}>
                <CardTitle>{parameters?.title?.value}</CardTitle>
                <ShowWithSkeleton
                    fetchAction={fetchAction}
                    height="100%"
                    width="95%"
                    streamingProperty={
                        fetchAction.data && fetchAction.data[parameters.chart.property]
                    }
                >
                    <WorkBubbleChart
                        data={fetchAction.data && fetchAction.data[parameters.chart.property]}
                        width={width}
                        dataPropertyName={parameters?.chart?.property}
                    />
                </ShowWithSkeleton>
            </Stack>
        </StyledBubbleChartCard>
    );
};

export default BubbleChartCard;
